import { render, staticRenderFns } from "./BlankColumn.vue?vue&type=template&id=fa757eb2&"
var script = {}
import style0 from "./BlankColumn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa757eb2')) {
      api.createRecord('fa757eb2', component.options)
    } else {
      api.reload('fa757eb2', component.options)
    }
    module.hot.accept("./BlankColumn.vue?vue&type=template&id=fa757eb2&", function () {
      api.rerender('fa757eb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/table/BlankColumn.vue"
export default component.exports